import { render } from "./StructureItems.vue?vue&type=template&id=a5c5c924&scoped=true"
import script from "./StructureItems.vue?vue&type=script&setup=true&lang=js"
export * from "./StructureItems.vue?vue&type=script&setup=true&lang=js"

import "./StyleStructure.scss?vue&type=style&index=0&id=a5c5c924&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c5c924"],['__file',"src/pages/scada/structure/StructureItems.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5c5c924"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5c5c924', __exports__)) {
    console.log('reload')
    api.reload('a5c5c924', __exports__)
  }
  
  module.hot.accept("./StructureItems.vue?vue&type=template&id=a5c5c924&scoped=true", () => {
    console.log('re-render')
    api.rerender('a5c5c924', render)
  })

}


export default __exports__